module.exports = __webpack_public_path__ + "img/icon_square-p.2080101a.svg";